"use client";

import { useEffect } from "react";

import { analytics } from "@/lib/analytics";

function getTrackTarget(event: MouseEvent) {
  if (!(event.target instanceof Element)) return null;
  const target = event.target.closest<HTMLElement>("[data-track]");
  if (!target?.closest("[data-homepage]")) return null;
  return target;
}

export function HomepageAnalytics() {
  useEffect(() => {
    function handleClick(event: MouseEvent) {
      const target = getTrackTarget(event);
      if (!target) return;

      const track = target.dataset.track;
      const location = target.dataset.trackLocation ?? "home";
      const label =
        target.dataset.trackLabel ??
        target.textContent?.trim().replace(/\s+/g, "_") ??
        track ??
        "unknown";

      switch (track) {
        case "reservation_clicked":
          analytics.reservationClicked(location);
          break;
        case "menu_clicked":
          analytics.menuBrowseClicked();
          analytics.ctaClicked("Menu", location);
          break;
        case "order_started":
          analytics.orderStarted();
          break;
        case "directions_clicked":
          analytics.directionsClicked();
          analytics.ctaClicked("Get_directions", location);
          break;
        case "phone_clicked":
          analytics.phoneClicked();
          break;
        case "cta_clicked":
          analytics.ctaClicked(label, location);
          break;
        default:
          if (track) {
            analytics.track(track, {
              category: "engagement",
              label: `${label}_${location}`,
            });
          }
      }
    }

    document.addEventListener("click", handleClick, { capture: true });
    return () => document.removeEventListener("click", handleClick, { capture: true });
  }, []);

  return null;
}
